import React from 'react';
import styles from '../Tabs.module.scss';
// @ts-ignore
import classNames from 'classnames';

type PropsType = {
    className?: string,
    children: React.ReactNode,
    dataCy?: string
}

const Nav = (props: PropsType) => {
    return (
        <div  
            className={classNames(
                styles.nav,
                props.className
            )}
            data-cy={props.dataCy}
        >
            {props.children}
        </div>
    )
}

export default Nav;